import 'scss/component/_superchat.scss';
import { getFormattedCreditsAmount, formatFullPrice } from 'util/format-credits';
import classnames from 'classnames';
import Icon from 'component/common/icon';
import LbcSymbol from 'component/common/lbc-symbol';
import Symbol from 'component/common/symbol';
import React from 'react';
type Props = {
  token?: string;
  chain?: string;
  amount?: number | '';
  badge?: boolean;
  className?: string;
  inheritStyle?: boolean;
  customAmounts?: {
    amountFiat: number;
    amountLBC: number;
  };
  fee?: boolean;
  hideTitle?: boolean;
  isEstimate?: boolean;
  isFiat?: boolean;
  noFormat?: boolean;
  precision?: number;
  showFree?: boolean;
  showFullPrice?: boolean;
  showLBC?: boolean;
  showPlus?: boolean;
  size?: number;
  hyperChat?: boolean;
  superChatLight?: boolean;
  icon?: string;
};

function CreditAmount({
  token,
  chain,
  amount,
  className,
  customAmounts,
  fee,
  hideTitle,
  isEstimate,
  isFiat,
  noFormat = false,
  precision = 2,
  showFree = false,
  showFullPrice = false,
  showLBC = true,
  showPlus = false,
  size,
  hyperChat,
  icon,
}: Props) {
  // return null, otherwise it will try and convert undefined to a string
  if (amount === undefined && customAmounts === undefined) return null;

  function getSymbol(amountText: any, size: number | undefined, chain: string | undefined) {
    return !token ? (
      <LbcSymbol postfix={amountText} size={size} />
    ) : (
      <Symbol postfix={amountText} size={size as any} chain={chain} />
    );
  }

  function getAmountText(amount: number, isFiat?: boolean) {
    const fullPrice = formatFullPrice(amount, 2);
    const isFree = parseFloat(String(amount)) === 0;
    const formattedAmount = showFullPrice ? fullPrice : getFormattedCreditsAmount(amount, precision);

    if (showFree && isFree) {
      return __('Free');
    } else {
      let amountText: any = noFormat ? amount : formattedAmount;

      if (showPlus && amount > 0) {
        amountText = `+${amountText}`;
      }

      if (showLBC && !isFiat) {
        amountText = getSymbol(amountText, size, chain);
      } else if (showLBC && isFiat) {
        amountText = (
          <p
            style={{
              display: 'inline',
            }}
          >
            ${isNaN(Number(amountText)) ? amountText : (Math.round(Number(amount) * 100) / 100).toFixed(2)}
          </p>
        );
      }

      if (fee) {
        amountText = __('%amount% fee', {
          amount: amountText,
        });
      }

      return amountText;
    }
  }

  return (
    <span
      title={amount && !hideTitle ? String(formatFullPrice(amount, 2)) : ''}
      className={classnames('credit-amount-wrapper', className, {
        hyperChat: hyperChat,
      })}
    >
      {icon && <Icon className="credit-amount__prefix-icon" icon={icon} />}

      {customAmounts
        ? Object.values(customAmounts).map((amount, index) => (
            <span key={String(amount)} className="credit-amount">
              {getAmountText(Number(amount), !index)}
            </span>
          ))
        : amount && <span className="credit-amount">{getAmountText(amount, isFiat)}</span>}

      {isEstimate ? (
        <span className="credit-amount__estimate" title={__('This is an estimate and does not include data fees')}>
          *
        </span>
      ) : null}
    </span>
  );
}

export default CreditAmount;
